import React from 'react';
import { X, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
const pains = [{
  title: 'Llegás sin saber qué entrenar',
  desc: 'Sin saber qué ejercicio o concepto vas a trabajar hoy.'
}, {
  title: 'Siempre los mismos ejercicios',
  desc: 'Sin progresión clara de una semana a la siguiente.'
}, {
  title: 'Perdés partidos sin saber por qué',
  desc: 'Sin sistema táctico claro ni plan para corregirlo.'
}, {
  title: 'No sabés qué decirle al grupo',
  desc: 'Antes del partido improvisás la charla y el equipo lo nota.'
}, {
  title: 'Jugadores que no mejoran',
  desc: 'No tenés forma de mostrarles que están progresando.'
}, {
  title: 'Consejos sueltos de YouTube',
  desc: 'Sin un método que respalde tus decisiones como DT.'
}, {
  title: 'El grupo se te va de las manos',
  desc: 'Conflictos, faltazos y un jugador que quiere mandar más que vos.'
}, {
  title: 'Fin de torneo sin resultados',
  desc: 'Sin planificación, el equipo llega a la recta final fundido.'
}];
export function PainPoints() {
  return <section className="py-10 md:py-20 bg-[#0F172A] px-4" data-id="element-210">
      <div className="max-w-3xl mx-auto" data-id="element-211">
        <div className="text-center mb-6 md:mb-10" data-id="element-212">
          <h2 className="font-display text-3xl md:text-5xl text-white mb-2 md:mb-4 uppercase" data-id="element-213">
            ¿TE PASA ESTO?
          </h2>
          <p className="text-sm md:text-lg text-gray-300 font-medium" data-id="element-214">
            Si entrenás futsal amateur en Argentina, esto te suena familiar:
          </p>
        </div>

        <div className="space-y-2 md:space-y-3 mb-8 md:mb-12" data-id="element-215">
          {pains.map((pain, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.04,
          duration: 0.35
        }} className="group flex items-center gap-3 md:gap-4 bg-gray-800 border-l-4 border-red-500 border border-red-900/40 rounded-r-xl pl-3 md:pl-4 pr-3 md:pr-5 py-3 md:py-4 shadow-sm hover:bg-gray-800/70 hover:border-l-red-400 transition-all duration-200" data-id="element-216">
              <div className="bg-red-950 text-red-400 w-8 h-8 md:w-10 md:h-10 rounded-full flex items-center justify-center shrink-0 group-hover:scale-110 group-hover:bg-red-900 transition-all border border-red-900/50" data-id="element-217">
                <X size={16} strokeWidth={3} data-id="element-218" />
              </div>

              <div className="flex-1 min-w-0" data-id="element-219">
                <h3 className="font-bold text-white text-sm md:text-base leading-tight" data-id="element-220">
                  {pain.title}
                </h3>
                <p className="text-xs md:text-sm text-gray-400 leading-snug mt-0.5" data-id="element-221">
                  {pain.desc}
                </p>
              </div>

              <ArrowRight size={16} className="text-red-500/40 shrink-0 group-hover:text-red-400 group-hover:translate-x-1 transition-all hidden md:block" data-id="element-222" />
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-223">
          <h3 className="font-display text-2xl md:text-4xl text-red-400 uppercase tracking-wide" data-id="element-224">
            ¿Cuántos torneos más vas a dirigir improvisando?
          </h3>
        </div>
      </div>
    </section>;
}